import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../../schema-validator";

const idEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("id"),
		name: Type.Union([Type.Literal("face id mismatch"), Type.Literal("bypassed ai detection")]),
		time: Type.Date(),
		details: Type.Object({
			similarity: Type.Optional(Type.Number({ minimum: 0, maximum: 1 })),
			success: Type.Optional(Type.Boolean()),
		}),
	}),
);

export default {
	idEvent,
};
